import { IUpdateSaidaMultiPUseCase } from "../../../presentation/useCases/update/update_saida_produtos_multi_use_case ";
import { SaidaProduto } from "../../models/saida_produtos_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class UpdateSaidaMultiPUseCase implements IUpdateSaidaMultiPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async updateSaidaMultiP(SaidaProduto: SaidaProduto[]): Promise<void> {
    
    await this.repository.updateSaidaMultiP(SaidaProduto)
  }
}
